import styled from "styled-components";
import Typography from "@material-ui/core/Typography/Typography";
import SwipeableViews from "react-swipeable-views";

export const MobileWrapper = styled.div`
    height: 100%;
`;

export const Title = styled(Typography)`
    flex-grow: 1;
    text-align: left;
`;

export const SwipeableViewsContainer = styled(SwipeableViews)`
    height: 100%;
`;



// WEBPACK FOOTER //
// ./src/mobile/Mobile.sc.js